import { type Palette } from '@mui/material'

import { type Sentiment } from '~types'

/**
 * Mapping from MUI icon names to Material Symbols names
 * This allows us to maintain the same import names while using Material Symbols
 */
export const iconMapping = {
  // Actions
  AccessTime: 'schedule',
  AccountTree: 'account_tree',
  Add: 'add',
  AddBoxOutlined: 'add_box',
  AddCircleOutlined: 'add_circle',
  AddTask: 'add_task',
  Alarm: 'alarm',
  Apartment: 'apartment',
  Assignment: 'assignment',
  AssignmentReturn: 'assignment_return',
  ArrowBack: 'arrow_back',
  ArrowDownward: 'arrow_downward',
  ArrowDropDown: 'arrow_drop_down',
  ArrowDropUp: 'arrow_drop_up',
  ArrowForward: 'arrow_forward',
  ArrowRightAlt: 'arrow_right_alt',
  ArrowUpward: 'arrow_upward',
  AssignmentTurnedIn: 'assignment_turned_in',
  Article: 'article',
  AttachFile: 'attach_file',
  AttachMoney: 'attach_money',
  AutoAwesome: 'auto_awesome',
  AutoMode: 'auto_mode',
  Autorenew: 'autorenew',
  Block: 'block',
  BuildOutlined: 'build',
  Business: 'business',
  Cached: 'cached',
  CallEnd: 'call_end',
  CallLog: 'call_log',
  CallMade: 'call_made',
  CallOutlined: 'call',
  CallReceived: 'call_received',
  ChatBubbleOutlined: 'chat_bubble',
  IosShare: 'ios_share',
  Check: 'check',
  CheckBox: 'check_box',
  CheckBoxOutlineBlank: 'check_box_outline_blank',
  CheckCircle: 'check_circle',
  CheckCircleOutlined: 'check_circle',
  ChevronLeft: 'chevron_left',
  ChevronRight: 'chevron_right',
  Circle: 'circle',
  CircleCircle: 'circle_circle',
  Close: 'close',
  CloudUpload: 'cloud_upload',
  Code: 'code',
  Comment: 'comment',
  ContentCopy: 'content_copy',
  CopyAll: 'copy_all',
  CropSquareOutlined: 'crop_square',
  CurrencyExchange: 'currency_exchange',
  DashboardCustomize: 'dashboard_customize',
  DockToRight: 'dock_to_right',
  Delete: 'delete',
  DeleteOutlined: 'delete',
  Download: 'download',
  Download2: 'download_2',
  DragIndicator: 'drag_indicator',
  DrawOutlined: 'draw',
  Edit: 'edit',
  EditOutlined: 'edit',
  EditSquareOutlined: 'edit_square',
  ContractEdit: 'contract_edit',
  Email: 'email',
  EmailOutlined: 'email',
  Error: 'error',
  ErrorOutlined: 'error_outline',
  Event: 'event',
  ExpandLess: 'expand_less',
  ExpandMore: 'expand_more',
  ExitToApp: 'exit_to_app',
  Feedback: 'feedback',
  FilterList: 'filter_list',
  Flag2: 'flag_2',
  Flag: 'flag',
  Flowchart: 'flowchart',
  Folder: 'folder',
  FolderOpen: 'folder_open',
  FormatBold: 'format_bold',
  FormatItalic: 'format_italic',
  FormatListBulleted: 'format_list_bulleted',
  FormatStrikethrough: 'strikethrough_s',
  FormatUnderlined: 'format_underlined',
  Function: 'function',
  Globe: 'globe',
  HeartCheckOutlined: 'heart_check',
  History: 'history',
  HomeOutlined: 'home',
  Image: 'image',
  Info: 'info',
  InfoOutlined: 'info',
  InstallDesktop: 'install_desktop',
  InsertPageBreak: 'insert_page_break',
  Inventory2Outlined: 'inventory_2',
  InventoryOutlined: 'inventory',
  KeyboardArrowDown: 'keyboard_arrow_down',
  KeyboardArrowLeft: 'keyboard_arrow_left',
  KeyboardArrowRight: 'keyboard_arrow_right',
  KeyboardArrowUp: 'keyboard_arrow_up',
  KeyboardBackspace: 'keyboard_backspace',
  KeyboardCommandKey: 'keyboard_command_key',
  Lan: 'lan',
  Language: 'language',
  Launch: 'launch',
  Link: 'link',
  Link2: 'link_2',
  LocationOn: 'location_on',
  LockOutlined: 'lock',
  Login: 'login',
  Logout: 'logout',
  MailOutlined: 'mail_outline',
  ManageAccountsOutlined: 'manage_accounts',
  manageSearch: 'manage_search',
  Contacts: 'contacts',
  MenuBook: 'menu_book',
  MonitorOutlined: 'monitor',
  MoreHoriz: 'more_horiz',
  MoreVert: 'more_vert',
  MyLocation: 'my_location',
  MyLocationOutlined: 'my_location',
  NoteOutlined: 'note',
  Notifications: 'notifications',
  Numbers: 'numbers',
  OpenInFull: 'open_in_full',
  OpenInNew: 'open_in_new',
  Paid: 'paid',
  PartnerExchange: 'partner_exchange',
  Pause: 'pause',
  Person: 'person',
  PersonAdd: 'person_add',
  PersonCheck: 'person_check',
  PersonOutlined: 'person',
  PersonRemove: 'person_remove',
  PersonSearch: 'person_search',
  Phone: 'phone',
  PhoneCallback: 'phone_callback',
  PhoneForwarded: 'phone_forwarded',
  PhoneOutlined: 'phone',
  PhotoCamera: 'photo_camera',
  PlayArrow: 'play_arrow',
  PublicOutlined: 'public',
  PublishedWithChanges: 'published_with_changes',
  QuestionAnswer: 'question_answer',
  Quiz: 'quiz',
  RadioButtonChecked: 'radio_button_checked',
  Reciept: 'receipt',
  ReceiptLongOutlined: 'receipt_long',
  RecordVoiceOver: 'record_voice_over',
  Redo: 'redo',
  Refresh: 'refresh',
  Remove: 'remove',
  ReplayOutlined: 'replay',
  Reply: 'reply',
  Restart: 'restart_alt',
  RocketLaunch: 'rocket_launch',
  SatelliteAlt: 'satellite_alt',
  Save: 'save',
  Science: 'science',
  Search: 'search',
  Segment: 'segment',
  Send: 'send',
  SendOutlined: 'send',
  SendToMobile: 'send_to_mobile',
  Sms: 'sms',
  SmsOutlined: 'sms',
  Sensors: 'sensors',
  SentimentSatisfiedOutlined: 'sentiment_satisfied',
  SentimentDissatisfiedOutlined: 'sentiment_dissatisfied',
  SentimentNeutralOutlined: 'sentiment_neutral',
  SentimentVerySatisfiedOutlined: 'sentiment_very_satisfied',
  ShareOutlined: 'share',
  ShortText: 'short_text',
  StopCircle: 'stop_circle',
  StylusNote: 'stylus_note',
  Subject: 'subject',
  SwapHoriz: 'swap_horiz',
  Sync: 'sync',
  TableViewOutlined: 'table_view',
  TaskAlt: 'task_alt',
  TextFields: 'text_fields',
  TimerPause: 'timer_pause',
  TextFormat: 'text_format',
  ThumbDownOffAlt: 'thumb_down_off_alt',
  ThumbUp: 'thumb_up',
  ThumbUpOutlined: 'thumb_up',
  ThumbUpOffAlt: 'thumb_up_off_alt',
  Translate: 'translate',
  TrendingUp: 'trending_up',
  UnarchiveOutlined: 'unarchive',
  Undo: 'undo',
  UnfoldMore: 'unfold_more',
  Upload: 'upload',
  UploadFile: 'upload_file',
  ViewComfyAltOutlined: 'view_comfy_alt',
  Visibility: 'visibility',
  VisibilityOff: 'visibility_off',
  VolumeOff: 'volume_off',
  VolumeUp: 'volume_up',
  Warning: 'warning',
  WarningAmberOutlined: 'warning_amber',
  WarningOutlined: 'warning',

  // Additional icons
  Archive: 'archive',
  AttachMoneyOutlined: 'attach_money',
  AutoAwesomeOutlined: 'auto_awesome',
  BarChart: 'bar_chart',
  BarChart4Bars: 'bar_chart_4_bars',
  BorderColor: 'format_border_color',
  CalendarTodayOutlined: 'calendar_today',
  Campaign: 'campaign',
  CampaignOutlined: 'campaign',
  Cancel: 'cancel',
  CancelPresentationOutlined: 'cancel_presentation',
  Chat: 'chat',
  Clear: 'clear',
  CopyAllOutlined: 'copy_all',
  DateRange: 'date_range',
  DoNotDisturbOn: 'do_not_disturb_on',
  Description: 'description',
  FactCheck: 'fact_check',
  FavoriteOutlined: 'favorite',
  FilterListOff: 'filter_list_off',
  FunctionsOutlined: 'functions',
  GroupOutlined: 'group',
  People: 'group',
  LabelOutlined: 'label',
  LanguageOutlined: 'language',
  LocationOnOutlined: 'location_on',
  Map: 'map',
  MoreTime: 'more_time',
  PageHeader: 'page_header',
  Pageview: 'pageview',
  PaletteOutlined: 'palette',
  PersonAddAlt1Outlined: 'person_add_alt_1',
  PushPin: 'push_pin',
  PhoneCallbackOutlined: 'phone_callback',
  Savings: 'savings',
  SecurityOutlined: 'security',
  Settings: 'settings',
  SettingsOutlined: 'settings',
  ShoppingCartOutlined: 'shopping_cart',
  StarOutlined: 'star',
  TableChart: 'table_chart',
  Tag: 'tag',
  TextFieldsOutlined: 'text_fields',
  ToggleOnOutlined: 'toggle_on',
  TripOrigin: 'trip_origin',
  RemoveCircle: 'remove_circle',
  EditNote: 'edit_note',
  WorkOutlined: 'work',

  // Icon suffix variants (for compatibility)
  AccessTimeIcon: 'schedule',
  AddIcon: 'add',
  ArrowBackIcon: 'arrow_back',
  ArrowCircleDown: 'arrow_circle_down',
  ArrowForwardIcon: 'arrow_forward',
  ArrowForwardIconOutlined: 'arrow_forward',
  ArrowRightAltIcon: 'arrow_right_alt',
  AttachFileIcon: 'attach_file',
  BlockIcon: 'block',
  BuildOutlinedIcon: 'build',
  BusinessIcon: 'business',
  Calculate: 'calculate',
  Category: 'category',
  CallEndIcon: 'call_end',
  CheckBoxIcon: 'check_box',
  CheckBoxOutlineBlankIcon: 'check_box_outline_blank',
  CheckCircleIcon: 'check_circle',
  CheckIcon: 'check',
  ChevronDownIcon: 'keyboard_arrow_down',
  ChevronLeftIcon: 'chevron_left',
  ChevronRightIcon: 'chevron_right',
  CloseIcon: 'close',
  CloudUploadIcon: 'cloud_upload',
  CommentIcon: 'comment',
  ContentCopyIcon: 'content_copy',
  CreditCardIcon: 'credit_card',
  DeleteIcon: 'delete',
  DownloadIcon: 'download',
  DrawOutlinedIcon: 'draw',
  EditIcon: 'edit',
  EmailIcon: 'email',
  ErrorIcon: 'error',
  ErrorOutlinedIcon: 'error_outline',
  ExpandMoreIcon: 'expand_more',
  FeedbackIcon: 'feedback',
  FilterAltIcon: 'filter_alt',
  FolderIcon: 'folder',
  HistoryIcon: 'history',
  InfoIcon: 'info',
  InstallDesktopIcon: 'install_desktop',
  KeyboardArrowDownIcon: 'keyboard_arrow_down',
  KeyboardArrowLeftIcon: 'keyboard_arrow_left',
  KeyboardArrowRightIcon: 'keyboard_arrow_right',
  KeyboardArrowUpIcon: 'keyboard_arrow_up',
  KeyboardBackspaceIcon: 'keyboard_backspace',
  LanguageIcon: 'language',
  LaunchIcon: 'launch',
  LocationOnIcon: 'location_on',
  MailOutlinedIcon: 'mail_outline',
  ManageAccountsOutlinedIcon: 'manage_accounts',
  MoreHorizIcon: 'more_horiz',
  MoreVertIcon: 'more_vert',
  MyLocationIcon: 'my_location',
  MyLocationOutlinedIcon: 'my_location',
  NoteOutlinedIcon: 'note',
  OpenInNewIcon: 'open_in_new',
  PauseIcon: 'pause',
  PhoneCallbackIcon: 'phone_callback',
  PhoneForwardedIcon: 'phone_forwarded',
  PhoneIcon: 'phone',
  PlayArrowIcon: 'play_arrow',
  Preview: 'preview',
  QuestionAnswerIcon: 'question_answer',
  QuizIcon: 'quiz',
  RecordVoiceOverIcon: 'record_voice_over',
  RefreshIcon: 'refresh',
  RemoveIcon: 'remove',
  ReplayOutlinedIcon: 'replay',
  ReplyIcon: 'reply',
  RestartAltIcon: 'restart_alt',
  SaveIcon: 'save',
  SatelliteIcon: 'satellite_alt',
  ScienceIcon: 'science',
  SearchIcon: 'search',
  SendIcon: 'send',
  SmsIcon: 'sms',
  SendToMobileIcon: 'send_to_mobile',
  TextFormatIcon: 'text_format',
  ThumbDownOffAltIcon: 'thumb_down_off_alt',
  ThumbUpIcon: 'thumb_up',
  ThumbUpOffAltIcon: 'thumb_up_off_alt',
  TranslateIcon: 'translate',
  TravelExploreIcon: 'travel_explore',
  VisibilityIcon: 'visibility',
  VisibilityOffIcon: 'visibility_off',
  VolumeOffIcon: 'volume_off',
  VolumeUpIcon: 'volume_up',
  WarningIcon: 'warning',
  DateRangeIcon: 'date_range',
  ZoomIn: 'zoom_in',
  ZoomOut: 'zoom_out',
} as const

// Export type for autocomplete
export type IconName = keyof typeof iconMapping

/**
 * Get Material Symbol name from MUI icon name
 */
export const getMaterialSymbolName = (muiIconName: string): string => {
  return (
    iconMapping[muiIconName as IconName] ||
    muiIconName.replace(/([a-z0-9])([A-Z])/g, '$1_$2').toLowerCase()
  )
}

export const getSentimentIconConfig = (
  sentiment: Sentiment,
  palette: Palette,
): { iconName: string; iconColor: string } => {
  switch (sentiment) {
    case 'positive':
      return { iconName: 'SentimentVerySatisfiedOutlined', iconColor: palette.success.main }
    case 'negative':
      return { iconName: 'SentimentDissatisfiedOutlined', iconColor: palette.warning.main }
    case 'neutral':
      return { iconName: 'SentimentSatisfiedOutlined', iconColor: palette.primary.main }
  }
}
